export default __webpack_public_path__ + "images/0bcc336e4298b38f3944ff0875b0d335.svg";